// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/main" + chunkId + "" + "c80d4b912d00287d6340" + ".js";
};